<template>
    <vs-row>
           <vs-row vs-justify="flex-end" class="my-6">
            <!-- <vs-dropdown>
              <vs-button  id="bgDarkAction" class="pr-4 font-semibold" type="filled" icon="expand_more" icon-after>Action</vs-button>
              <vs-dropdown-menu class="accountsDropdown">
                <vs-dropdown-item @click="confirmDelete = true">
                  Delete
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown> -->
            <div class="verticalCenter">
                <vs-button type="filled" color="danger" class="font-semibold" @click="suspendAccount(suspendStatus ? false : true)">{{ suspendStatus ? 'Unsuspend Account' : 'Suspend Account' }}</vs-button>
            </div>
        </vs-row>
        <vs-row class="tblBgClrProf">
        <vs-table v-model="selected" :data="profilesList" hoverFlat class="w-full">
                        
            <template slot="thead">
                <vs-th sort-key="name">PROFILE NAME</vs-th>
                <vs-th sort-key="category">PROFILE INITIALS</vs-th>
                <vs-th sort-key="order_status">CREDIT CARDS</vs-th>
                <vs-th sort-key="order_status">DATE ADDED</vs-th>
                <vs-th sort-key="order_status">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td @click.native.stop>
                        <p class="product-name font-medium truncate">{{ userName }}</p>
                    </vs-td>

                    <vs-td @click.native.stop>
                        <p class="product-category">{{ tr._id }}</p>
                    </vs-td> 

                    <vs-td @click.native.stop>
                        <vs-row class="product-name font-medium truncate" :key="index" v-for="(issuer, index) in tr.issuers">
                            <vs-row class="showIssuerCards">
                                <vs-col>
                                    <div @click="showIssuerCards(tr.profileId,issuer.issuer_id)">
                                        <div class="profIssuerCircle mt-1 mr-2" :style="{'background-color': issuer.issuerColor}"></div>{{ issuer.issuerName[0] }} ( {{ issuer.cardsCount }} )
                                    </div>
                                    <ul>
                                        <li 
                                            v-if="card.card.issuer == issuer.issuer_id && tr.profileId == profId" 
                                            :key="i" v-for="(card, i) in issuerCardsList" 
                                            v-show="showCards"
                                            @click.stop="showCardDetails(tr.profileId,card._id)"
                                            >
                                            <vs-row class="my-1">
                                                <div class="ml-6">
                                                    <img :src="$ApiKeys.IMAGE_BASE_URL+card.card.photo" width="30" height="20"/>
                                                </div>
                                                <div class="ml-3">
                                                    {{ card.card.name }}
                                                </div>
                                            </vs-row>
                                        </li>
                                    </ul>
                                </vs-col>
                            </vs-row>
                        </vs-row>
                    </vs-td>

                    <vs-td @click.native.stop>
                        <p class="product-name font-medium truncate">{{ tr.dateAdded | formatDate }}</p>
                    </vs-td>

                    <vs-td @click.native.stop="deletePro(tr.profileId)" style="cursor:pointer;color:red;">
                        <x-icon class="ml-4"/>
                    </vs-td>

                    </vs-tr>
                </tbody>
                </template>
            </vs-table>
        </vs-row>
          <vs-popup class="holamundo cardDetail" :title="cardDetails.card.name" :active.sync="showDetails">
                <img :src="$ApiKeys.IMAGE_BASE_URL+cardDetails.card.photo" class="title-icon"/>
                <vs-row class="borderB p-3 pb-6">
                    <vs-col vs-lg="3">
                        <div class="py-1">
                            <div class="detailLabel">Issuer</div>
                            <div class="whiteText detailContent">{{ cardDetails.card.issuer ? cardDetails.card.issuer.name : 'Not Available' }}</div>
                        </div>
                        <div class="mt-5 py-1">
                            <div class="detailLabel">Credit Limit</div>
                            <div class="whiteText detailContent">{{ cardDetails.credit_limit ? '$'+cardDetails.credit_limit : 'Not Available' }}</div>
                        </div>
                    </vs-col>
                    <vs-col vs-lg="3">
                        <div class="py-1">
                            <div class="detailLabel">Card Name</div>
                            <div class="whiteText detailContent">{{ cardDetails.card ? cardDetails.card.name : 'Not Available' }}</div>
                        </div>
                        <div class="mt-5 py-1">
                            <div class="detailLabel">Open Date</div>
                            <div class="whiteText detailContent" v-if="cardDetails.open_date">{{ cardDetails.open_date | formatDate }}</div>
                            <div class="whiteText detailContent" v-if="!cardDetails.open_date">Not Available</div>
                        </div>
                    </vs-col>
                    <vs-col vs-lg="3">
                        <div class="py-1">
                            <div class="detailLabel">Card Type</div>
                            <div class="whiteText detailContent">{{ cardDetails.card.card_type ? cardDetails.card.card_type : 'Not Available' }}</div>
                        </div>
                        <div class="mt-5 py-1">
                            <div class="detailLabel">Authorized User</div>
                            <div class="whiteText detailContent">{{ cardDetails.authorized ? 'Yes' : 'No' }}</div>
                        </div>
                    </vs-col>
                    <vs-col vs-lg="3">
                        <div class="py-1">
                            <div class="detailLabel">Nickname</div>
                            <div class="whiteText detailContent">{{ cardDetails.nickname ? cardDetails.nickname : 'Not Available' }}</div>
                        </div>
                    </vs-col>
                    <vs-row class="inputContainer p-0">
                            <vs-checkbox v-model="cardDetails.five_twenty_four" vs-name="rule-type" :vs-value="true" class="m-2 mt-5 ml-0" :disabled="true"/>
                            <div class="detailContent pt-5">Counts toward Chase 5/24</div>
                    </vs-row>
                </vs-row>
                <vs-row class="borderB p-3 pb-6">
                    <vs-col vs-lg="6">
                        <div class="py-1">
                            <div class="detailLabel">Annual Fee</div>
                            <div class="whiteText detailContent">{{ '$'+cardDetails.card.annual_fee }}</div>
                        </div>
                        <!-- <div class="mt-5 py-1">                        
                            <div class="mt-2 detailLabel">Effective Fee Description</div>
                            <div class="whiteText detailContent" v-if="cardDetails.card.effective_fee_description" v-html="cardDetails.card.effective_fee_description"></div>
                            <p class="whiteText detailContent" v-else>Not Available</p>
                        </div> -->
                    </vs-col>
                    <vs-col vs-lg="6">
                        <div class="detailLabel">Points</div>
                        <p class="whiteText detailContent" v-if="cardDetails.card.points_categories && cardDetails.card.points_categories.length == 0">Not Available</p>
                        <p class="whiteText" v-if="cardDetails.card.points_categories"  :key="index" v-for="(category, index) in cardDetails.card.points_categories">
                            {{ category.multiplier }} x {{ category.points_category.name }}
                        </p>
                    </vs-col>
                </vs-row>
                <vs-row class="p-3 pb-6">
                    <vs-col v-if="cardDetails.card.activeRules && cardDetails.card.activeRules.length > 0">
                        <vs-row class="mb-2">
                            <img :src="require('@/assets/images/active-rules/scale.png')" class="rulesIcon mr-2"/>
                            <p class="detailLabel">Active Rules</p>
                        </vs-row>
                        <div class="ml-6" :key="ruleIndex" v-for="(rule, ruleIndex) in cardDetails.card.activeRules">
                            <p class="p-1 whiteText font-semibold">{{ rule.rule.name }}</p>
                            <p class="p-1 whiteText">{{ rule.rule.description }}</p>
                        </div>
                    </vs-col>
                    <vs-col v-if="cardDetails.card.activeRules && cardDetails.card.activeRules.length == 0">
                        <div>No Active Rules</div>
                    </vs-col>
                </vs-row>
          </vs-popup>
          <vs-popup class="holamundo" title="Status" :active.sync="showDeleteStatus.status">
              <h5>{{ showDeleteStatus.msg }}</h5>
          </vs-popup>
          <vs-popup class="holamundo" title="Status" :active.sync="showSuspendStatus.status">
              <h5>{{ showSuspendStatus.msg }}</h5>
          </vs-popup>
          <vs-popup class="holamundo"  title="Status" :active.sync="confirmDelete">
                <h5>Are you sure that you want to delete?</h5>
                <vs-row vs-justify="flex-end">
                    <vs-button @click="deleteProfile" class="mr-4">Yes</vs-button>
                    <vs-button @click="confirmDelete = false">No</vs-button>
                </vs-row>
            </vs-popup>
    </vs-row>
</template>

<script>
import { UploadIcon, XIcon } from 'vue-feather-icons';
import { genericErrorMessage, toast } from '@/keys/toast-messages';

export default {
    components: {
        UploadIcon,
        XIcon
    },
    data(){
        return {
            deleteProfileId: '',
            confirmDelete: false,

            userId: '',
            userName: '',
            profilesList: [],

            selected: [],
            showDeleteStatus: {
                msg: '',
                status: false
            },
            showSuspendStatus: {
                msg: '',
                status: false
            },

            profId: '',
            issuerId: '',
            issuerCardsList: [],

            suspendStatus: false,

            showCards: false,
            showDetails: false,

            cardDetails: {
                card: {
                    photo: '',
                    name: ''
                }
            },
            genericErrorMessage,
            toast
        }
    },
    methods: {
        deletePro(id){
            this.deleteProfileId = id;
            this.confirmDelete = true;
        },
        showIssuerCards(profId,issuerId){
            this.profId = profId;
            this.issuerId = issuerId[0];
            this.getIssuerCards();
        },
        async suspendAccount(status){
            return new Promise((resolve, reject) => {
                this.$axios.patch(this.$ApiKeys.BASE_URL+this.$EndPoints.SuspendAccounts,
                [this.userId],
                {
                    params:{
                        suspendUsers:status
                    }
                } 
               ).then(async res => {
                    if(res.data.success == true){
                        this.showSuspendStatus = {
                            msg: res.data.message,
                            status: true
                        };
                        this.suspendStatus = !this.suspendStatus;
                        this.getProfiles();
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    if(e.response.data.errors.profileId){
                        this.showSuspendStatus = {
                            msg: e.response.data.errors.profileId,
                            status: true
                        };
                    }
                    else {
                        this.showSuspendStatus = {
                            msg: '',
                            status: false
                        };
                        if(e.response.status !== 401){
                            this.toast(this.genericErrorMessage());
                        }
                    }
                });
            });
        },
        async deleteProfile(){
            this.confirmDelete = false;
                this.$vs.loading({
                    background: 'rgba(1,2,3,.2)'
                });

                return new Promise((resolve, reject) => {
                    this.$axios.post(this.$ApiKeys.BASE_URL+this.$EndPoints.DeleteProfiles,{
                        profileId: this.deleteProfileId
                    }, 
                    { 
                        headers: {
                            'Authorization': this.$localStorage.get('token')
                        }
                    }).then(async res => {
                        this.$vs.loading.close();
                        if(res.data.success){
                            this.showDeleteStatus = {
                                msg: res.data.data.message,
                                status: true
                            };
                            this.getProfiles();
                        } else {
                            this.toast(this.genericErrorMessage());
                        }
                    }).catch(e => {
                        this.$vs.loading.close();
                        if(e.response.data.errors.profile){
                            this.showDeleteStatus = {
                                msg: 'Cannot delete the only profile of the user. Try deleting the user account.',
                                status: true
                            };
                        }
                        else {
                            this.showDeleteStatus = {
                                msg: '',
                                status: false
                            };
                            if(e.response.status !== 401){
                                this.toast(this.genericErrorMessage());
                            }
                        }
                    });
                });
            
        },
        // async deleteProfiles(){
        //     this.confirmDelete = false;
        //     if(this.selected.length > 0){
        //         this.$vs.loading({
        //             background: 'rgba(1,2,3,.2)'
        //         });

        //         let profileIds = [];
        //         await this.selected.forEach(async function(item, index){
        //                     profileIds.push(item.profileId);
        //         });

        //         return new Promise((resolve, reject) => {
        //             this.$axios.post(this.$ApiKeys.BASE_URL+this.$EndPoints.DeleteProfiles,{
        //                 profileId: profileIds
        //             }, 
        //             { 
        //                 headers: {
        //                     'Authorization': this.$localStorage.get('token')
        //                 }
        //             }).then(async res => {
        //                 this.$vs.loading.close();
        //                 if(res.data.success == true){
        //                     this.showDeleteStatus = {
        //                         msg: res.data.data.message,
        //                         status: true
        //                     };
        //                     this.getProfiles();
        //                     this.selected = [];
        //                 }
        //             }).catch(e => {
        //                 this.$vs.loading.close();
        //                 if(e.response.data.errors.profileId){
        //                     this.showDeleteStatus = {
        //                         msg: e.response.data.errors.profileId,
        //                         status: true
        //                     };
        //                 }
        //                 else {
        //                     this.showDeleteStatus = {
        //                         msg: '',
        //                         status: false
        //                     };
        //                 }
        //             });
        //         });
        //     }
        //     else
        //     {
        //         this.showDeleteStatus = {
        //             msg: 'Select atleast one Profile to delete',
        //             status: true
        //         };
        //     }
            
        // },
        showCardDetails(profileId,cardId){
            this.$vs.loading({
                background: 'rgba(1,2,3,.2)'
            });
            return new Promise(async (resolve, reject) => {
                await this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.ProfileCardInfo, { 
                    params: {
                        profileId: profileId,
                        cardId: cardId
                    },
                    headers: {
                        'Authorization': this.$localStorage.get('token')
                    }
                }).then(async res => {
                    this.$vs.loading.close();
                    if(res.data.success){
                        resolve(
                            this.cardDetails = res.data.data,
                            this.showDetails = true
                        );
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    this.$vs.loading.close();
                    if(e.response.status !== 401){
                        this.toast(this.genericErrorMessage());
                    }
                });
            });
        },
        getIssuerCards(){
            this.$vs.loading({
                background: 'rgba(1,2,3,.2)'
            });
            return new Promise(async (resolve, reject) => {
                await this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.ProfileIssuerCards, { 
                    params: {
                        profileId: this.profId,
                        issuerId: this.issuerId
                    },
                    headers: {
                        'Authorization': this.$localStorage.get('token')
                    }
                }).then(async res => {
                    this.$vs.loading.close();
                    if(res.data.success){
                        resolve(
                            this.issuerCardsList = res.data.data,
                            this.showCards = true,
                        );
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    this.$vs.loading.close();
                    if(e.response.status !== 401){
                        this.toast(this.genericErrorMessage());
                    }
                    this.showCards = false;
                });
            });
        },
        getProfiles(){
            return new Promise(async (resolve, reject) => {
                await this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.Profiles, { 
                    params: {
                        userId: this.userId
                    }
                }).then(async res => {
                    this.$vs.loading.close();
                    if(res.data.success){
                        resolve(
                            this.profilesList = res.data.data
                        );
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    this.$vs.loading.close();
                    if(e.response.status !== 401){
                        this.toast(this.genericErrorMessage());
                    }
                });
            });
        }
    },
    created(){
        this.userId = this.$route.params._id;
        this.userName = this.$route.params.firstName+' '+this.$route.params.lastName;
        this.suspendStatus = this.$route.params.suspended;
        this.getProfiles()
        this.$vs.loading({
            background: 'rgba(1,2,3,.2)'
        });
    }
}
</script>

<style>
    @import './profilesStyle.css';
</style>